import { render, staticRenderFns } from "./HandoverObjectsTable.vue?vue&type=template&id=12100b34&scoped=true"
import script from "./HandoverObjectsTable.vue?vue&type=script&lang=js"
export * from "./HandoverObjectsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12100b34",
  null
  
)

export default component.exports